// Map for translating route parts to Hebrew names
export const countryNameMap: Record<string, string> = {
  thailand: 'תאילנד',
  vietnam: 'וייטנאם',
  cambodia: 'קמבודיה',
};

// Function to get country name in Hebrew
export const getCountryName = (countrySlug: string): string => {
  return countryNameMap[countrySlug] || countrySlug;
};

// Interface for breadcrumb items
export interface BreadcrumbItem {
  name: string;
  url: string;
  isCurrentPage?: boolean;
}

// Function to generate article breadcrumbs
export const generateArticleBreadcrumbs = (
  country: string,
  articleTitle: string,
  slug: string
): BreadcrumbItem[] => {
  const countryName = getCountryName(country);

  return [
    {
      name: 'יעדים במזרח',
      url: '/international',
    },
    {
      name: countryName,
      url: `/international/${country}`,
    },
    {
      name: articleTitle,
      url: `/international/${country}/article/${slug}`,
      isCurrentPage: true,
    },
  ];
};

// Function to generate destination breadcrumbs
export const generateDestinationBreadcrumbs = (
  country: string,
  destinationTitle: string,
  destinationSlug: string
): BreadcrumbItem[] => {
  const countryName = getCountryName(country);

  return [
    {
      name: 'יעדים במזרח',
      url: '/international',
    },
    {
      name: countryName,
      url: `/international/${country}`,
    },
    {
      name: destinationTitle,
      url: `/international/${country}/destination/${destinationSlug}`,
      isCurrentPage: true,
    },
  ];
};

// Function to generate country hub breadcrumbs
export const generateCountryBreadcrumbs = (
  country: string
): BreadcrumbItem[] => {
  const countryName = getCountryName(country);

  return [
    {
      name: 'יעדים במזרח',
      url: '/international',
    },
    {
      name: countryName,
      url: `/international/${country}`,
      isCurrentPage: true,
    },
  ];
};
